import React from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const CartProductInfo = ({ item: { price, image, name, quantity } }) => {
  return (
      <div className="cart__product-info">
         <div className="cart__product image-container">
              {image && (<img className="cart__product image" alt={name} src={image} />)}
          </div>
      <div className="cart__product details">
        <div className="title-container">
          <p className="title">{name}</p>
          {quantity > 1 && <p className="quantity">x{quantity}</p>}
        </div>
        <p className="price">{price}</p>
      </div>
    </div>
  );
};

const MiniCart = () => {
  const dispatch = useDispatch();
  const {
    quantity,
    orderTotal,
    checkoutUrl,
    showInfo,
    orderRows,
  } = useSelector((state) => state.cart);

  const onToggle = () => {
    dispatch(toggle());

    const bodyEl = document.querySelector('body');
    bodyEl.classList.toggle('navbar__mobile-menu--active');
  };

  const hasItems = orderRows.length > 0;
  return (
    <div className={`cart cart--mini ${showInfo ? 'cart--mini--active' : ''}`}>
      <a
        className="cart__link--block"
        rel="nofollow"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          // toggle cart
          onToggle();
        }}
      >
        <i className="cart__icon">
          <span className="cart__quantity">
            {quantity > 9 ? '9+' : quantity}
          </span>
        </i>
        <span className="cart__title hide">
          {translate('minicart.checkout')}
        </span>
      </a>
      <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
        <div className="cart__products-wrapper">
          {hasItems ? (
            orderRows.map((item) => (
              <CartProductInfo key={item.articleNumber} item={item} />
            ))
          ) : (
            <p> {translate('minicart.empty')}</p>
          )}
        </div>

        <p className="cart__info-row">
          <b>{translate('minicart.total')}</b>
          <span>{orderTotal}</span>
        </p>

        <div className="cart__checkout-wrapper">
          <a href={checkoutUrl} className="cart__checkout-button">
            {translate('minicart.checkout')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
